import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class DeclarationExportRequest {
    static jsonMap = {
        idCampagnes: { key: 'idCampagnes', converter: new (ArrayClassConverterFactory.build(Number))(), optional: true },
        idRefMouvements: { key: 'idRefMouvements', converter: new (ArrayClassConverterFactory.build(Number))(), optional: true },
        idCahiers: { key: 'idCahiers', converter: new (ArrayClassConverterFactory.build(Number))(), optional: true },
        dateMin: { key: 'dateMin', optional: true, default: '' },
        dateMax: { key: 'dateMax', optional: true, default: '' }
    };

    idCampagnes?: number[];
    idRefMouvements?: number[];
    idCahiers?: number[];
    dateMin?: string;
    dateMax?: string;

    constructor() {
        this.idCampagnes = [];
        this.idRefMouvements = [];
        this.idCahiers = [];
    }
}
